import { LaborVersions } from './LaborVersions';

const labVersions = document.querySelectorAll('.tx-avmlabor-laborversions-list');

labVersions.forEach((element) => {
    new LaborVersions(element);
});
